import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../shared/environments/environment';
import {concatMap, EMPTY, expand, map, Observable, toArray} from 'rxjs';
import {Params} from '@angular/router';
import {IPaginatedResponse} from '../typing/response.interface';
import {IOrder, IOrderBatchUpdateResult, IOrderCreate, IOrderDataUpdate, IOrderUpdate} from '../typing/order.interface';
import {Order} from '../classes/order.class';
import { TimeZoneService } from './time-zone.service';

@Injectable({
    providedIn: 'root'
})
export class OrdersService {

    constructor(
        private http: HttpClient,
        private timeZoneService: TimeZoneService,
    ) {
    }

    // получение всего списка задач
    getAllOrders(query: Params): Observable<Order[]> {
        return this.getOrdersPage(query, 1).pipe(
            expand(response =>
                response.links.next ? this.getOrdersPage(query, response.meta.currentPage + 1) : EMPTY
            ),
            concatMap(response => response.data),
            toArray()
        );
    }

    // постраничное получение задач
    private getOrdersPage(query: Params, page: number): Observable<IPaginatedResponse<Order>> {
        const params = { ...query, page, limit: 400 };
        return this.http.get<IPaginatedResponse<IOrder>>(`${environment.API_BASE_PATH}/orders`, { params }).pipe(
            map(response => ({
                ...response,
                data: response.data.map(order => new Order(order, this.timeZoneService))
            }))
        );
    }

    getOrder(id: number): Observable<IOrder> {
        return this.http.get<IOrder>(`${environment.API_BASE_PATH}/order/${id}`);
    }

    getList(query: Params = {}): Observable<IPaginatedResponse<IOrder>> {
        return this.http.get<IPaginatedResponse<IOrder>>(`${environment.API_BASE_PATH}/orders`, {params: query});
    }

    uploadOrders(formData: FormData): Observable<any> {
        return this.http.post(`${environment.API_BASE_PATH}/orders/upload`, formData);
    }

    // Массовое обновление: бэкенд сохраняет что может и возвращает, какие заявки не сохранены и почему
    updateOrders(data: IOrderDataUpdate[]): Observable<IOrderBatchUpdateResult> {
        return  this.http.put<IOrderBatchUpdateResult>(`${environment.API_BASE_PATH}/orders/batch-update`, data);
    }

    createOrder(data: IOrderCreate): Observable<IOrder> {
        return  this.http.post<IOrder>(`${environment.API_BASE_PATH}/order`, data);
    }

    updateOrder(data: IOrderUpdate): Observable<IOrder> {
        return  this.http.put<IOrder>(`${environment.API_BASE_PATH}/order/${data.id}`, data);
    }

    deleteOrders(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/orders/`, {
            body: data
        });
    }

    aqsiOrder(orderId: number | string ):  Observable<void> {
        return this.http.post<void>(`${environment.API_BASE_PATH}/cash-provider/order`, {orderId});
    }

}
